<template>
  <div>
    <vs-table :data="chfLeads">
      <template slot="header">
        <h3>
          Leady z Kalkulatora CHF
        </h3>
      </template>
      <template slot="thead">
        <vs-th>
          ID
        </vs-th>
        <vs-th>
          Name
        </vs-th>
        <vs-th>
          Email
        </vs-th>
        <vs-th>
          Date
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="i" v-for="(tr, i) in data" >
          <vs-td :data="data[i].id">
            {{data[i].id}}
          </vs-td>

          <vs-td :data="data[i].name">
            {{data[i].name}}
          </vs-td>

          <vs-td :data="data[i].email">
            {{data[i].email}}
          </vs-td>

          <vs-td :data="data[i].created_at">
            {{data[i].created_at | date}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import CHF_LEADS from '../graphql/chfLeads.gql';

export default {
  name: "ChfLeads",
  data() {
    return {
      chfLeads: []
    }
  },
  async mounted() {
    const { data: { chfLeads } } = await this.$apollo.query({
      query: CHF_LEADS
    });

    this.chfLeads = chfLeads
  }
}
</script>

<style scoped>

</style>
